import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { toastr } from 'react-redux-toastr';

import copyStringToClipboard from '../../../../util/copyStringToClipboard';

import Select from '../../../Select';
import Avatar from './Avatar';

import { fetchVoices } from '../../../../store/actions/voice-bots';
import { BotsCreators } from '../../../../store/actions/bots';
import { CompanyActions } from '../../../../store/actions/companies';

import './style.css';

const SubMenuSettings = ({ isActive, bot, onClickOutside }) => {
  const [botData, setBotData] = useState({
    _id: '',
    title: '',
    avatar: { url: '', blob: null },
    selectedVoice: { label: '', value: '' },
  });

  const { voices } = useSelector((state) => state.voiceBot);
  const { signedUser } = useSelector((state) => state.users);

  const dispatch = useDispatch();

  useEffect(() => {
    if (signedUser?.selectedCompany?._id) {
      const companyId = signedUser.selectedCompany._id;
      dispatch(CompanyActions.getCompany({ companyId }));
    }
  }, [signedUser?.selectedCompany?._id]);

  useEffect(() => {
    if (
      bot?.type === 'voice' &&
      bot?.voiceSettings &&
      bot?.voicebotInstanceId
    ) {
      const { voicebotInstanceId, voiceSettings } = bot;
      const { codeUser, idProject } = voiceSettings;

      const params = { codeUser, idProject, voicebotInstanceId };
      dispatch(fetchVoices({ params }));
    }
  }, [bot?.type, bot?.voiceSettings, bot?.voicebotInstanceId]);

  useEffect(() => {
    if (bot?.voiceSettings) {
      const { _id, title, img, voiceSettings } = bot;
      const { idIvrVoice } = voiceSettings;

      const hasVoices = voices && Array.isArray(voices);

      const findVoiceOption = hasVoices
        ? voices.find((voice) => voice.IdIvrVoice === idIvrVoice)
        : null;

      const selectedVoice = findVoiceOption
        ? {
            label: findVoiceOption.DeIvrVoice,
            value: findVoiceOption.IdIvrVoice,
          }
        : null;

      setBotData({
        _id,
        title,
        avatar: { url: img, blob: null },
        selectedVoice,
      });
    }
  }, [bot, isActive, voices]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBotData({ ...botData, [name]: value });
  };

  const handleAvatarChange = (file) => {
    const newFileUrl = URL.createObjectURL(file);
    const newImageData = { url: newFileUrl, blob: file };

    setBotData({ ...botData, avatar: newImageData });
  };

  const voiceOptions = useMemo(() => {
    return Array.isArray(voices)
      ? voices.map((voice) => ({
          value: voice.IdIvrVoice,
          label: voice.DeIvrVoice,
        }))
      : [];
  }, [voices]);

  function handleCopyAytyId() {
    copyStringToClipboard(bot?.voiceSettings?.idIvrFlowDynamic);
    toastr.success('Copiado', 'Id copiado com sucesso');
  }

  const handleUpdateSettings = () => {
    const { avatar, title, selectedVoice } = botData;

    if (!selectedVoice) {
      toastr.warning(
        'Ops',
        'Por favor, informe o tipo de voz a ser configurada.'
      );
      return;
    }

    const payload = {
      ...bot,
      title,
      avatarFile: avatar.blob,
      voiceSettings: {
        ...bot.voiceSettings,
        idIvrVoice: selectedVoice.value,
      },
    };

    dispatch(BotsCreators.updateVoiceBotRequest(payload));
  };

  return (
    <>
      <div
        className={classnames('submenu__settings__overlay', {
          'submenu__settings__overlay--is-open': isActive,
        })}
        onClick={onClickOutside}
      />
      <div
        className={classnames('submenu__settings', {
          'submenu__settings--is-open': isActive,
        })}
      >
        <h3 className="submenu__settings__title">Configuração do Voicebot</h3>

        <Avatar url={botData?.avatar?.url} onChange={handleAvatarChange} />

        <div className="submenu__settings__input-container d-flex">
          <span className="label">Id do fluxo:</span>
          <div className="ml-2">
            <span>{bot?.voiceSettings?.idIvrFlowDynamic}</span>
            <img
              alt="Copy icon"
              src="/assets/images/icons/icon_copiar.svg"
              className="pointer ml-2"
              title="copiar"
              onClick={() => handleCopyAytyId()}
            />
          </div>
        </div>

        <div className="submenu__settings__input-container">
          <label className="label">Nome do bot:</label>
          <input
            name="title"
            placeholder="Ex.: RH"
            value={botData.title}
            onChange={handleInputChange}
            maxLength={26}
          />
        </div>

        <Select
          label="Tipo de voz"
          options={voiceOptions}
          onChange={(option) =>
            handleInputChange({
              target: { name: 'selectedVoice', value: option },
            })
          }
          value={botData.selectedVoice}
          noOptionsMessage="Opção não encontrada"
        />

        <div className="submenu__settings__footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleUpdateSettings}
          >
            salvar
          </button>
        </div>
      </div>
    </>
  );
};

export default SubMenuSettings;
